import axios from 'axios';
import apiUrl from '../../../constants';

export function imageList(shippingID,token){
    let path = `STD/${shippingID}`;
    let input = ({
        key: path,
      });
    
    return axios({
        method: 'post',
        url: `${apiUrl.api_url}getListObjectFroms3`,
        data: input,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
}




// WEBPACK FOOTER //
// ./src/services/B2b/services/imageList.js